import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
    selector: 'app-funnel-chart-card',
    templateUrl: './funnel-chart-card.component.html',
    styleUrls: ['./funnel-chart-card.component.scss'],
    standalone: false
})
export class WidgetFunnelChartCardComponent implements OnInit, OnDestroy {
  static key = 100824;

  @Input('item') item: any;
  @Input('pageKey') pageKey: any;
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>();
  @ViewChild('funnelChartDiv', { static: true }) funnelChartDiv!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];
  error_name: any;

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService,
  ) {
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((query: any) => {
      this.loadApiData();
    }));
  }

  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.funnelChartDiv.nativeElement);
    this.loadFunnelConfig();
  }

  loadFunnelConfig() {
    this.heading = this.item?.config?.['report_heading'] || 'Funnel Chart';
    this.config = {
      fixedCategories: this.item?.config?.['funnel_fixed_categories'] || [
        'Intake', 'BI Outcome', 'PA Process', 'PA Submission', 'Treatement ready',
      ],
      colours: this.item?.config?.['funnel_colours'] || {
        'BI Submission': '#4a7bed',
        'Commercial': '#48bb78',
        'Government': '#ecc94b',
        'New Patients': '#f56565',
        'Existing Patients': '#805ad5',
        'PA Required by Policy': '#ed64a6',
        'No New PA Required': '#a0aec0',
        'No PA Required': '#ed8936',
        'Other PA Provider': '#ecbf44',
        'PA Initiated': '#e53e3e',
        'PA opt out': '#a0aec0',
        'PA submitted': '#4a7bed',
        'PA Not Submitted': '#a0aec0',
        'Denied': '#e53e3e',
        'Ready for treatment': '#48bb78',
      },
      defaultColour: this.item?.config?.['funnel_default_colour'] || '#a0aec0',
      dynamicColumns: this.item?.config?.['funnel_dynamic_columns'] || [
        { field: 'patient_type',       label: 'Patient Type' },
        { field: 'payer_type_name',    label: 'Payer Type' },
        { field: 'group_name',         label: 'Groups' },
        { field: 'practice',           label: 'Practices' },
        { field: 'practice_locn_name', label: 'Locations' },
      ],
      breakdownDimensions: this.item?.config?.['funnel_breakdown_dimensions'] || [
        { field: 'patient_type',       label: 'Patient Type' },
        { field: 'payer_type_name',    label: 'Payer Type' },
        { field: 'group_name',         label: 'Groups' },
        { field: 'practice',           label: 'Practices' },
        { field: 'practice_locn_name', label: 'Locations' },
      ],
      chartHeight: 500,
      cardWidth: 200,
      cardHeight: 80,
      colWidth: 240,
    };
  }

  loadApiData() {
    // let api = this.item?.config?.['list_of_api'] || {};
    let api = this.item?.config?.['list_of_api'] || {};
    if (api && (this.filterService.isEmptyObject(this.filterService.baseQuery) == false)) {
      let obj: any = { "api_key": api };
      let query = Object.assign({}, this.filterService.baseQuery, obj);
      query["report_typ"] = this.filterService.report_type;
      query['module_key'] = this.apiService.getModuleKey();

      // HARD CODED STUFF
      // query['report_typ'] = 'D';
      // query['client_key'] = 5001;
      // END HARD CODED STUFF
      // let endPoint = this.item.config?.["list_of_api_endpoint"] || '';
      let endPoint = this.item.config?.["widget_endpoint"] || '';
      // this.apiService.apiBaseUrl = "eblue"
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe((res: any) => {
          this.isDataLoaded = true;
          this.data = res == null ? [] : res;
          this.error_name = '';
        }, (err: any) => {
          this.data = [];
          this.error_name = friendlyApiErrorMessage(err);
          console.log(err);
        })
      );
    } else {
      // Use local mock data when API is not configured
      this.loadMockData();
    }
  }

  loadMockData() {
    this.reqSubcription.push(
      this.httpClient.get('assets/mock-data/funnel-chart.json').subscribe((res: any) => {
        this.isDataLoaded = true;
        this.data = res == null ? [] : res;
        this.error_name = '';
      }, (err: any) => {
        this.data = [];
        this.error_name = friendlyApiErrorMessage(err);
        console.log(err);
      })
    );
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe());
  }
}
